<!-- 底部导航栏 -->
<template>
  <div class="tabbar">
    <div class="tab-box">
      <div class="item" v-for="(item, index) in imgs" :key="index" @click="select(index,item.url)">
        <img :src="item.img" class="tab-img" v-if="idxs!=index" />
        <img :src="item.selectImg" class="tab-img" v-if="idxs==index" />
        <span
          class="tab-text"
          :style="idxs==index?'color:#FF4343;font-weight:bold':''"
        >{{item.title}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      imgs: [
        {
          img: require("./img/icon02.png"),
          selectImg: require("./img/icon01.png"),
          title: "首页",
          url: "Index"
        },
        // {
        //   img: require("./img/unhome.png"),
        //   selectImg: require("./img/home.png"),
        //   title: "求职招聘",
        //   url: "Home"
        // },
        // {
        //   img: require("./img/unIdeology.png"),
        //   selectImg: require("./img/Ideology.png"),
        //   title: "思想政治",
        //   url: "Ideology"
        // },

        {
          img: require("./img/icon06.png"),
          selectImg: require("./img/icon07.png"),
          title: "活动通知",
          url: "Activity"
        },
        {
          img: require("./img/uncontant.png"),
          selectImg: require("./img/contant.png"),
          title: "联系我们",
          url: "contant"
        },
        {
          img: require("./img/unmin.png"),
          selectImg: require("./img/min.png"),
          title: "个人中心",
          url: "Profile"
        }
      ],
      check: true
    };
  },
  computed: {},
  methods: {
    ...mapMutations(["SETT_ABBAR"]),
    select(val, url) {
      var that = this;
      this.SETT_ABBAR(val);
      if (that.$route.name != url) {
        that.$router.replace({
          name: url
        });
      }
    }
  },
  computed: {
    ...mapState(["idxs"])
  },
  created() {
    // var idx = localStorage.getItem("index");
    // if (idx) {
    //   this.idx = idx;
    // }
  },
  mounted() {}
};
</script>
<style lang='less' scoped>
.tabbar {
  .tab-box {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    box-shadow: 0.1rem 0 0.05rem rgba(0, 0, 0, 0.3);
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 0.22rem 0;
      background: #fff;
      .tab-img {
        width: 0.48rem;
        height: 0.48rem;
      }
      .tab-text {
        font-size: 0.22rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(179, 179, 179, 1);
        padding: 0.2rem 0 0;
      }
    }
  }
}
.tabbar::before {
  content: "";
  display: block;
  height: 1.45rem;
  width: 100%;
}
</style>